<template>
    <div class="TicketLoadItemTimes">
        <div class="item">
            <div class="circle start"></div>
            <h4 v-if="start">{{ start | formatTime }}</h4>
            <h4 v-else>Unset</h4>
        </div>
        <div class="item">
            <div class="circle end"></div>
            <h4 v-if="start">{{ end | formatTime }}</h4>
            <h4 v-else>Unset</h4>
        </div>

        <div class="circleBridge"></div>
    </div>
</template>

<script>
export default {
    name: 'TicketLoadItemTimes',

    props: {
        start: { type: [Date, String] },
        end: { type: [Date, String] },
    },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';
@import 'globals.scss';
$circle-size: 15px;
$circle-bridge-width: 2px;

.TicketLoadItemTimes {
    position: relative;
    font-size: 14px;

    .item {
        display: flex;
        align-items: center;
        height: 18px;
    }

    .circle {
        width: $circle-size;
        height: $circle-size;
        margin-right: 10px;
        border-radius: 50%;
        position: relative;
        z-index: 1;

        &.start {
            border: 2px solid $link-color;
            background-color: $bg-color-1;
        }

        &.end {
            background-color: $link-color;
        }
    }

    .circleBridge {
        @include absolute-center(y);
        left: math.div($circle-size, 2) - math.div($circle-bridge-width, 2);
        width: $circle-bridge-width;
        height: 60%;
        border-left: 2px solid $link-color;
    }
}
</style>
